export const heroData = {
  title: "Segmentna Vrata",
  subtitle: "Vrhunskog Kvaliteta",
  description: "Profesionalna ugradnja segmentnih garažnih vrata sa preko 15 godina iskustva. Kvalitet, garancija i pouzdanost.",
  badge: "Profesionalna Ugradnja"
};

export const aboutData = {
  title: "Vaš Partner za Kvalitetna Garažna Vrata",
  description: "Specijalizovani smo za ugradnju segmentnih vrata. Sa više od decenije iskustva, garantujemo profesionalnu uslugu od merenja do finalne montaže.",
  projects: "200+",
  projectsLabel: "Uspešno Realizovanih Projekata"
};

export const galleryData = [
  {
    id: 1,
    title: "Stambeni Objekat Dedinje",
    location: "Beograd",
    type: "Rezidencionalna vrata",
    image: "https://readdy.ai/api/search-image?query=modern%20luxury%20garage%20door%20installation%20on%20elegant%20residential%20house%20with%20beautiful%20landscape%20professional%20quality%20workmanship%20clean%20white%20background&width=400&height=300&seq=1&orientation=landscape"
  },
  {
    id: 2,
    title: "Poslovni Kompleks",
    location: "Novi Sad", 
    type: "Industrijska vrata",
    image: "https://readdy.ai/api/search-image?query=commercial%20industrial%20garage%20door%20installation%20on%20business%20building%20professional%20sectional%20doors%20quality%20craftsmanship%20modern%20architecture&width=400&height=300&seq=2&orientation=landscape"
  },
  {
    id: 3,
    title: "Vila Senjak",
    location: "Beograd",
    type: "Automatska vrata",
    image: "https://readdy.ai/api/search-image?query=automatic%20sectional%20garage%20door%20installation%20luxury%20villa%20modern%20house%20professional%20installation%20high%20quality%20materials%20contemporary%20design&width=400&height=300&seq=3&orientation=landscape"
  }
];

export const servicesData = [
  {
    id: 1,
    title: "Besplatna Procena",
    description: "Dolazimo na vašu adresu, merimo prostor i dajemo detaljnu procenu troškova bez obaveze.",
    icon: "ri-ruler-line"
  },
  {
    id: 2, 
    title: "Profesionalna Ugradnja",
    description: "Stručna montaža segmentnih vrata sa garancijom kvaliteta i dugotrajnosti.",
    icon: "ri-tools-line"
  },
  {
    id: 3,
    title: "Servis i Održavanje",
    description: "Redovan servis i održavanje vaših garažnih vrata za optimalne performanse.",
    icon: "ri-settings-3-line"
  }
];